module.exports = __webpack_public_path__ + "img/pe.caf4f1df.svg";